import { App } from "antd";
import $ from "jquery";
import { useEffect, useRef } from "react";
import { WP_TABLE_LIST_SELECTOR, relocateAttachment } from "../../../backbone/attachmentSortable.js";
import { getDefaultTreeStore } from "../../../hooks/tree/bridge/rmlMediaBridge.js";
let attachmentSortableBindingCount = 0;
let unbindAttachmentSortableDom;
function resolveFolderForGridSort() {
    const treeStore = getDefaultTreeStore();
    return treeStore.getTreeItemById(treeStore.selectedId) ?? treeStore.getTreeItemById($(".rml-container .aiot-active").data("id"));
}
function bindAttachmentSortableDom(messageRef) {
    let lastIdInView = false;
    const onGridSortStart = function() {
        const attachmentsBrowser = $(this).parents(".attachments-browser").data("backboneView");
        if (!attachmentsBrowser?.collection) {
            return;
        }
        const { collection } = attachmentsBrowser;
        lastIdInView = collection.models[collection.models.length - 1].id;
    };
    const onGridSortUpdate = function(_e, ui) {
        const attachmentsBrowser = $(this).parents(".attachments-browser").data("backboneView");
        if (!attachmentsBrowser) {
            return;
        }
        const next = ui.item.next();
        const nextId = next.html() ? next.data("id") : false;
        const attachmentId = ui.item.data("id");
        void relocateAttachment(messageRef.current, resolveFolderForGridSort(), attachmentId, nextId, lastIdInView, ui);
    };
    $(document).on("sortstart", ".attachments-browser ul.attachments", onGridSortStart);
    $(document).on("sortupdate", ".attachments-browser ul.attachments", onGridSortUpdate);
    const $listTable = $(WP_TABLE_LIST_SELECTOR);
    $listTable.sortable({
        disabled: true,
        appendTo: "body",
        tolerance: "pointer",
        scrollSensitivity: 50,
        placeholder: "ui-sortable-helper-wp-media-list",
        scrollSpeed: 50,
        distance: 10,
        cursor: "move",
        start: (_e, ui)=>{
            ui.placeholder.height(ui.helper[0].scrollHeight);
            lastIdInView = +$listTable.find('tr:last > .check-column > input[type="checkbox"]').val();
        },
        update: (_e, ui)=>{
            const next = ui.item.next();
            const nextId = next.html() ? next.find('> .check-column > input[type="checkbox"]').val() : false;
            const attachmentId = ui.item.find('> .check-column > input[type="checkbox"]').val();
            const folderId = $(".rml-container .aiot-active").data("id");
            void relocateAttachment(messageRef.current, getDefaultTreeStore().getTreeItemById(folderId), attachmentId, nextId, lastIdInView, ui);
        }
    });
    return ()=>{
        $(document).off("sortstart", ".attachments-browser ul.attachments", onGridSortStart);
        $(document).off("sortupdate", ".attachments-browser ul.attachments", onGridSortUpdate);
        try {
            $listTable.sortable("destroy");
        } catch  {
        // Not initialised on this page.
        }
    };
}
function useAttachmentSortable() {
    const { message } = App.useApp();
    const messageRef = useRef(message);
    messageRef.current = message;
    useEffect(()=>{
        if (process.env.PLUGIN_CTX !== "pro") {
            return;
        }
    /* Silence is golden... Until you have PRO Version! */ }, []);
}
export { useAttachmentSortable };
